import { OpenIDConnectDiscoverySchema } from "./fetch-openid-connect-discovery.js";
import { redirectToProxy } from "@scalar/helpers/url/redirect-to-proxy";
import { isLocalUrl } from "@scalar/helpers/url/is-local-url";
import { coerceValue } from "@scalar/workspace-store/schemas/typebox-coerce";
//#region src/v2/blocks/scalar-auth-selector-block/helpers/fetch-oauth2-metadata.ts
var isAllowedMetadataUrl = (url) => url.protocol === "https:" || url.protocol === "http:" && isLocalUrl(url.href);
/** Fetches the exact RFC8414 metadata URL, without applying OIDC issuer URL conventions. */
var fetchOAuth2Metadata = async (url, proxyUrl, customFetch = fetch) => {
	try {
		const metadataUrl = new URL(url.trim());
		if (!isAllowedMetadataUrl(metadataUrl)) return [/* @__PURE__ */ new Error("OAuth2 metadata URL must use HTTPS or HTTP for local development URLs"), null];
		const response = await customFetch(redirectToProxy(proxyUrl, metadataUrl.href));
		if (!response.ok) return [/* @__PURE__ */ new Error(`Failed to fetch OAuth2 metadata: ${response.status} ${response.statusText}`), null];
		const data = coerceValue(OpenIDConnectDiscoverySchema, await response.json());
		if (!data.authorization_endpoint && !data.token_endpoint) return [/* @__PURE__ */ new Error("Invalid OAuth2 metadata: missing or invalid endpoints"), null];
		for (const endpoint of [data.authorization_endpoint, data.token_endpoint]) if (endpoint && !isAllowedMetadataUrl(new URL(endpoint))) return [/* @__PURE__ */ new Error("OAuth2 metadata endpoints must use HTTPS or HTTP for local development URLs"), null];
		return [null, data];
	} catch (error) {
		return [error instanceof Error ? error : /* @__PURE__ */ new Error("Failed to fetch OAuth2 metadata"), null];
	}
};
//#endregion
export { fetchOAuth2Metadata };

//# sourceMappingURL=fetch-oauth2-metadata.js.map